import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col md:items-center md:justify-between md:flex-row px-2.5 py-2.5 bg-white border-primary-1 relative" }
const _hoisted_2 = { class: "p-4 flex flex-row items-center justify-between" }
const _hoisted_3 = {
  fill: "currentColor",
  viewBox: "0 0 20 20",
  class: "w-6 h-6"
}
const _hoisted_4 = {
  "fill-rule": "evenodd",
  d: "M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM9 15a1 1 0 011-1h6a1 1 0 110 2h-6a1 1 0 01-1-1z",
  "clip-rule": "evenodd"
}
const _hoisted_5 = {
  "fill-rule": "evenodd",
  d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
  "clip-rule": "evenodd"
}

import Logo from "@/assets/logo.svg";
import { Routes } from "@/router";
import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'NavBar',
  setup(__props) {

const open = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: { name: _unref(Routes).DASHBOARD },
        class: "logo hover:text-primary-1 transition-colors"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Logo), { class: "w-36" })
        ]),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("button", {
        class: "md:hidden rounded-lg focus:outline-none focus:shadow-outline",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (open.value = !open.value))
      }, [
        (_openBlock(), _createElementBlock("svg", _hoisted_3, [
          _withDirectives(_createElementVNode("path", _hoisted_4, null, 512), [
            [_vShow, !open.value]
          ]),
          _withDirectives(_createElementVNode("path", _hoisted_5, null, 512), [
            [_vShow, open.value]
          ])
        ]))
      ])
    ]),
    _createElementVNode("nav", {
      class: _normalizeClass(["flex-col grow pb-4 md:pb-0 md:flex md:justify-end md:flex-row absolute top-full left-0 right-0 bg-white px-2.5 md:static border-b border-primary-1 md:border-0", { flex: open.value, hidden: !open.value }])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ]))
}
}

})